import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Link, Route, Routes } from 'react-router-dom';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import CalendarLayout from './components/CalendarLayout';
import TennisPlayerSearch from './components/TennisPlayerSearch';
import { Drawer } from 'antd';
import AddTournament from './components/AddTournament';

// moment 로케일 설정
moment.locale('ko');

// 네비게이션 컴포넌트
const Navigation = ({ onPlayerSearchOpen }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // 화면 크기 변경 감지
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        setIsMenuOpen(true);
      } else {
        setIsMenuOpen(false);
      }
    };

    // 초기 설정
    handleResize();

    // 리사이즈 이벤트 리스너 추가
    window.addEventListener('resize', handleResize);

    // 클린업
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light mb-4">
      <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <Link className="navbar-brand" to="/">Nawaplay</Link>
        <button 
          className="navbar-toggler" 
          type="button" 
          onClick={toggleMenu}
          style={{
            padding: '0.25rem 0.5rem',
            fontSize: '1.25rem',
            lineHeight: '1',
            backgroundColor: 'transparent',
            border: '1px solid rgba(0,0,0,.1)',
            borderRadius: '0.25rem',
            cursor: 'pointer'
          }}
        >
          <span 
            className="navbar-toggler-icon"
            style={{
              display: 'inline-block',
              width: '1.5em',
              height: '1.5em',
              verticalAlign: 'middle',
              backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%2833, 37, 41, 0.75%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e")`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundSize: '100%'
            }}
          ></span>
        </button>
        <div 
          className={`navbar-collapse ${isMenuOpen ? 'show' : ''}`}
        >
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link 
                className="nav-link" 
                to="/"
                onClick={() => window.innerWidth < 992 && setIsMenuOpen(false)}
              >
                대회 일정
              </Link>
            </li>
            <li className="nav-item">
              <button 
                className="nav-link btn btn-link p-0" 
                style={{ color: '#007bff', textDecoration: 'none' }}
                onClick={onPlayerSearchOpen}
              >
                테니스 선수 검색
              </button>
            </li>
            <li className="nav-item">
              <Link 
                className="nav-link" 
                to="/add-tournament"
                onClick={() => window.innerWidth < 992 && setIsMenuOpen(false)}
              >
                대회 등록
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

function App() {
  const [playerSearchOpen, setPlayerSearchOpen] = useState(false);

  return (
    <Router>
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Navigation onPlayerSearchOpen={() => setPlayerSearchOpen(true)} />
        <main style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<CalendarLayout />} />
            <Route path="/add-tournament" element={<AddTournament />} />
          </Routes>
        </main>
        <div className="text-center text-muted mb-4">
          Powered by Nawaplay
        </div>
        <Drawer
          title="테니스 선수 랭킹 검색"
          placement="right"
          width={600}
          onClose={() => setPlayerSearchOpen(false)}
          open={playerSearchOpen}
        >
          <TennisPlayerSearch />
        </Drawer>
      </div>
    </Router>
  );
}

export default App; 